import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { E_CertificateTypes } from '@/enums'


interface T_Organization {
  id: number
  name: E_CertificateTypes,
  title: string,
}

interface T_OrganizationsDrawerStore {
  isOrganizationsDrawerVisible: boolean
  showOrganizationsDrawer: () => void
  hideOrganizationsDrawer: () => void

  selectedOrganization: T_Organization | null
  setSelectedOrganization: (organization: T_Organization) => void
}

export const useOrganizationsDrawerStore = create<
  T_OrganizationsDrawerStore
>()(devtools((set) => ({

  isOrganizationsDrawerVisible: false,
  showOrganizationsDrawer: () => set({ isOrganizationsDrawerVisible: true }),
  hideOrganizationsDrawer: () => set({ isOrganizationsDrawerVisible: false }),

  selectedOrganization: null,
  setSelectedOrganization: (organization) => set({ selectedOrganization: organization }),

})))
